import * as React from "react";
import cx from "classnames";

type Props = {
  tabsToDisplay: {
    label: string;
    isActive: boolean;
    onClick: () => void;
  }[];
  className?: string;
};

const Tabs = (props: Props) => {
  const { tabsToDisplay, className } = props;

  const tabsCn = cx("filter--tabs", {
    [className]: !!className,
  });

  const tabs = () => {
    return tabsToDisplay.map((t) => {
      const cn = cx("filter--tabs__item", {
        "filter--tabs__item--active": t.isActive,
      });

      return (
        <button className={cn} key={t.label} onClick={t.onClick}>
          {t.label}
        </button>
      );
    });
  };

  return (
    <div className={tabsCn}>
      <div className="filter--tabs__items">{tabs()}</div>
    </div>
  );
};

export default Tabs;
